// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LF-z","hovered":"MF-z","hoverImage":"NF-z","mainImage":"OF-z","imageNoBackground":"PF-z","fullSizeImage":"QF-z"};